import { Students } from '../../services';
import { createRestSlices, createGenericSlice, applyReducers } from './rest';

const {
    initialState,
    createReducer,
    startCreateReducer,
    getReducer,
    listReducer,
    updateReducer,
    deleteReducer,
    createAction,
    startCreateAction,
    getAction,
    listAction,
    updateAction,
    deleteAction,
} = createRestSlices(Students);

// remove parent generic slice
const { reducer: removeParentReducer, action: removeParentAction } = createGenericSlice(Students, {
    name: 'removeParent',
    action: (student, parent) => Students.removeParent(student, parent),
    onSuccess: (state, action) => ({ ...state, student: action.student }),
    onError: (state, error) => ({ ...state }),
});

/* Export reducer */
export default (state = initialState, action) => {
    return applyReducers(state, action, [
        createReducer, startCreateReducer,
        getReducer, listReducer,
        updateReducer, deleteReducer,
        removeParentReducer
    ]);
}

/* Export CRUD actions */
export const startCreateStudent  = startCreateAction;
export const createStudent       = createAction;
export const loadStudent         = getAction;
export const loadStudents        = listAction;
export const updateStudent       = updateAction;
export const deleteStudent       = deleteAction;
export const removeStudentParent = removeParentAction;
